import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import "components/DBB/components/DBBCreateContractModal/components/DBBCarSection/DBBCarSection.scss";
import { createFormHelper } from "lib/Form";

import type { DBBContractFormPayload } from "components/DBB/components/DBBCreateContractModal/components/DBBCreateContractForm";

export type DBBContractCar = {
  reg_nr: string;
  vin_nr: string;
  make: string;
  model: string;
  model_year: number | null;
  mileage: number | null;
};

export const DBB_MANDATORY_CAR_FIELDS: (keyof DBBContractCar)[] = ["reg_nr", "vin_nr", "make", "model", "mileage"];

export const isCarFieldMissing = (value: DBBContractCar[keyof DBBContractCar]) => (typeof value === "number" ? value <= 0 : !value);

const FormHelper = createFormHelper<DBBContractFormPayload>();

export const DBBCarSection = () => {
  const { t } = useTranslation();
  const { watch, formState } = FormHelper.useFormContext();

  const car = watch("car");

  return (
    <div className="section">
      <label className="big car-section-label">
        <Icon className="car" />
        {t("v8_car", "Car")}
      </label>

      <Form.Group>
        <Form.Field width={6} required error={formState.isSubmitted && !car.reg_nr}>
          <label>{t("v8_license_plate", "License plate")}</label>
          <FormHelper.Field.Input name="car.reg_nr" inputProps={{ placeholder: t("v8_license_plate", "License plate") }} />
        </Form.Field>
        <Form.Field width={6} required error={formState.isSubmitted && !car.vin_nr}>
          <label>{t("v8_vin_number", "VIN number")}</label>
          <FormHelper.Field.Input name="car.vin_nr" inputProps={{ placeholder: t("v8_vin_number", "VIN number") }} />
        </Form.Field>
        <Form.Field width={6} required error={formState.isSubmitted && isCarFieldMissing(car.mileage)}>
          <label>{t("v8_mileage", "Mileage")}</label>
          <FormHelper.Field.Input name="car.mileage" nullable inputProps={{ placeholder: t("v8_mileage", "Mileage"), type: "number" }} />
        </Form.Field>
      </Form.Group>

      <Form.Group>
        <Form.Field width={6} required error={formState.isSubmitted && !car.make}>
          <label>{t("v8_brand", "Brand")}</label>
          <FormHelper.Field.Input name="car.make" inputProps={{ placeholder: t("v8_brand", "Brand") }} />
        </Form.Field>
        <Form.Field width={6} required error={formState.isSubmitted && !car.model}>
          <label>{t("v8_model", "Model")}</label>
          <FormHelper.Field.Input name="car.model" inputProps={{ placeholder: t("v8_model", "Model") }} />
        </Form.Field>
        <Form.Field width={6}>
          <label>{t("v8_model_year", "Model Year")}</label>
          <FormHelper.Field.Input name="car.model_year" nullable inputProps={{ placeholder: t("v8_model_year", "Model Year"), type: "number" }} />
        </Form.Field>
      </Form.Group>
    </div>
  );
};
